import { render, staticRenderFns } from "./informes.vue?vue&type=template&id=b5a32f74"
import script from "./informes.vue?vue&type=script&lang=js"
export * from "./informes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports